module.exports = __webpack_public_path__ + "img/402.00269b05.jpg";